import React from "react";
import { makeStyles } from "@mui/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
    marginTop: "2%",
  },
  title: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    fontSize: "40px",
    fontWeight: "500",
    marginTop: "80px",
    textAlign: "center",
  },
  media: {
    height: 400,
    width: "100%",
  },
});

export default function AdminDashboard() {
  const classes = useStyles();
  // const imageSrc = `https://neilpatel.com/wp-content/uploads/2017/09/content-marketing-tools.jpg`;
  // const imageSrc = `https://cdni.rbth.com/rbthmedia/images/2018.10/original/5bc920f985600a58bc5f370e.jpg`;
  const imageSrc = `images/kadomi-shop-illustration-dashboard.png`;

  return (
    <div className={classes.root}>
      <Card className={classes.root}>
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            Admin • Kadomi.ch
          </Typography>
          <Typography>
            Bienvenue sur l'espace d'administration de Kadomi.ch
          </Typography>
          <Typography>
            Saisissez vos articles, ajoutez vos plateformes de ventes de choix
            et vendez vos articles.
          </Typography>
        </CardContent>
        <CardMedia
          className={classes.media}
          image={imageSrc}
          title="Contemplative Reptile"
        />
      </Card>
    </div>
  );
}
